import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import NavbarMain from "../pageComponents/NavbarMain";


import Api from "../servicios/api/Api";
import {ToastContainer} from "react-toastify";
import libToast from "../lib/LibToast";
import 'react-toastify/dist/ReactToastify.css';
import CLoading from "../cmain/CLoading";
import CError from "../pageComponents/CError";

const apiCliente = Api.getApiCliente();
const WrapperCMain = ({titulo, children, urlPage, elemMeta}) => {
  
  const [cuenta, setCuenta] = useState({})
  const [statePage, setStagePage] = useState({isLoading: true})
  
  useEffect(() => {
    //cargar datos del api
    
    (async () => {
      const response = await apiCliente.cuenta();
      if (!response.success) {
        libToast.alert("Error " + response.msg);
        setStagePage({isError: true, message: response.msg});
        return;
      }
      setCuenta(response.data.cuenta);
      setStagePage({success: true});
    })()
    
  }, []);
  
  
  if (statePage.isError) {
    return <CError msg={statePage.message}/>;
  }
  
  if (statePage.isLoading) {
    return <CLoading/>
  }
  
  return (<>
    <Helmet>
      <title>{titulo} :: Researching</title>
    </Helmet>
    
    <div id="app">
      <NavbarMain
        urlPage={urlPage}
        cuenta={cuenta}
      />
      <section id="contenidoMain">
        <div className="contenidoMainWrapper" style={{maxWidth: "1200px", margin: "0 auto"}}>
          {children}
        </div>
      </section>
    
    </div>
    <ToastContainer/>
    {elemMeta}
  
  </>);
}

export default WrapperCMain;